import { DiscoveryProductsRecentlyAddedResponseType } from "@sellar-io/api-v2/types";

import { twMerge } from "tailwind-merge";

type AwardTier = "gold" | "silver" | "bronze";

export type ProductAwardContainerType = "Keg" | "Cask" | "Bottle & Can";

type SubCategoryAward = {
  subCategory: string;
  subCategoryMedal: AwardTier;
  type: ProductAwardContainerType;
};

export type ProductAwardData = {
  productId: number;
  overallCategory: string | null;
  overallCategoryMedal: AwardTier | null;
  subCategories: SubCategoryAward[];
};

import { DietaryDisplayList } from "../../../components/dietaryDisplayList/DietaryDisplayList";

import { AwardBadge } from "./SharedCardComponents/AwardBadge";
import { SpotlightProductCardImage } from "./SharedCardComponents/SpotlightProductCardImage";
import { SpotlightSharedCardContainer } from "./SharedCardComponents/SpotlightSharedCardContainer";
import { productAwardData } from "./SpotlightProductCard.shared";

export const SpotlightProductCard = ({
  product,
  className,
  onClick,
  showAwardBadge,
}: {
  product: DiscoveryProductsRecentlyAddedResponseType[number];
  className?: string;
  onClick: () => void;
  showAwardBadge?: boolean;
}) => {
  let productHeroImages = product.ProductImages.filter(
    (ProductImage) => !!ProductImage.url,
  ).map((ProductImage) => ProductImage.url);

  if (productHeroImages.length === 0 && product.heroImageUrl)
    productHeroImages = [product.heroImageUrl];

  return (
    <SpotlightSharedCardContainer className={"shadow-lg"}>
      <div
        key={product.id}
        className={twMerge("flex h-full cursor-pointer flex-col", className)}
        onClick={onClick}
      >
        <SpotlightProductCardImage
          product={product}
          showAwardBadge={showAwardBadge}
        />
        <div className="mt-2 flex grow flex-col justify-between">
          <div className="px-2 pb-1">
            <p className={"text-sm font-semibold text-zinc-800"}>
              {product.name}{" "}
              <DietaryDisplayList
                dietaryRequirements={{
                  VG: Boolean(product.vegan),
                  GF: Boolean(product.glutenFree),
                  LF: Boolean(product.lactoseFree),
                }}
                mode="text"
              />
            </p>
            <p className={"text-xs text-zinc-500"}>
              {[product.kind, `${product.abv}%`].join(" // ")}
            </p>
            {(() => {
              const awardData = productAwardData.find(
                (a) => a.productId === product.id,
              );
              if (!showAwardBadge || !awardData) return null;
              return (
                <div className="mt-1 flex flex-wrap items-center gap-1">
                  {awardData.subCategories.map((sub) => (
                    <div
                      key={sub.subCategory}
                      className="flex items-center gap-1"
                    >
                      <AwardBadge tier={sub.subCategoryMedal} type={sub.type} />
                      <span className="text-xs text-zinc-500">
                        {sub.subCategory}
                      </span>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
          <p className="mt-2 border-t border-[#D4D4D8] bg-zinc-50 px-2 py-1.5 text-xs font-bold text-zinc-500">
            &nbsp;
            {product.containerTypes
              .map((type) => type.toUpperCase())
              .join(" • ")}
          </p>
        </div>
      </div>
    </SpotlightSharedCardContainer>
  );
};
